import {
    ChangeEvent, DataDisplayEvent, DropdownSelectionEvent, DynamicDbDisplayValueSearchEvent, LookupModelSearchEvent,
    LookupModelSelectionEvent, Textbox, 
} from "@mcleod/components";
import { AutogenLayoutFileImportDetail } from "./autogen/AutogenLayoutFileImportDetail";
import { Model, ModelRow } from "@mcleod/core";

export class FileImportDetail extends AutogenLayoutFileImportDetail {
    private _parentDataType: string;
    private _setEffectFields: string[];

    override onLoad() {
        this.switchUseDefault.captionLabelMarginBottom = 8;
    }

    textboxFormatOnDataDisplay(event: DataDisplayEvent) {
        const textbox = event.target as Textbox;
        const field = textbox.field;
        this.textboxDateFormat.visible = event.rowData.get(field, null)?.toLowerCase().startsWith("date") === true;
    }

    set parentDataType(value: string) {
        this._parentDataType = value;
        this.textboxTableName.refreshDynamicItems();
        this.evaluateSetEffectAvailability();
    }

    set setEffectFields(value: string[]) {
        this._setEffectFields = value;
        this.evaluateSetEffectAvailability();
    }

    set setEffectHelpline(value: string) {
        this.textboxSetEffectValue.tooltip = value;
    }

    textboxTableNameBeforeDynamicDbDisplayValueSearch(event: DynamicDbDisplayValueSearchEvent) {
        this.addDataTypeToEvent(event);
    }

    private addDataTypeToEvent(event: DynamicDbDisplayValueSearchEvent) {
        event.addAddlValue("data_type", this._parentDataType);
    }

    textboxTableNameOnChange(event: ChangeEvent) {
        const tableNameTextbox = event.target as Textbox;
        if (event.userInitiatedChange) {
            this.textboxFieldName.clear();
        }
        this.textboxFieldName.enabled = !tableNameTextbox.isEmpty();
    }

    textboxFieldNameOnDataDisplay() {
        this.evaluateSetEffectAvailability();
    }
    
    textboxFieldNameBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.data_type = this._parentDataType;
        event.filter.selected_table_name = this.textboxTableName?.selectedItem.value;
    }

    textboxFieldNameOnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.evaluateSetEffectAvailability();
        this.updateSchemaFieldInfo(event.selection);
    }

    private evaluateSetEffectAvailability() {
        if (this._setEffectFields != null) {
            const selectedFieldName = this.textboxFieldName.getFirstLookupModelData()
                ?.getString(this.textboxFieldName.lookupModelResultField);
            if (selectedFieldName != null && this._setEffectFields?.includes(selectedFieldName)) {
                this.textboxSetEffectValue.visible = true;
                this.textboxSetEffectValue.refreshDynamicItems();
            } else {
                this.textboxSetEffectValue.visible = false;
                this.sourceFileImportDetail.activeRow?.set("set_effect_value", null);
            }
        }
    }

    private updateSchemaFieldInfo(row: ModelRow) {
        const activeRow = this.sourceFileImportDetail.activeRow;
        activeRow.set("caption", row?.getString("caption"));
        activeRow.set("format", row?.getString("format"));
        activeRow.set("helpline", row?.getString("helpline"));
        activeRow.set("required", row?.getString("required") ?? "N");
        activeRow.set("upshifted", row?.getString("upshifted") ?? "N");
    }

    textboxSetEffectValueBeforeDynamicDbDisplayValueSearch(event: DynamicDbDisplayValueSearchEvent) {
        this.addDataTypeToEvent(event);
    }

    textboxSetEffectValueAfterDropdownSelection(event: DropdownSelectionEvent) {
        const activeRow = this.sourceFileImportDetail.activeRow;
        const tableName = activeRow.getString("table_name", null);
        const fieldName = activeRow.getString("field_name", null);
        const setEffectValue = event.selection.value;
        const body = {
            selected_table_name: tableName,
            field_name: fieldName,
            set_effect_value: setEffectValue
        }
        Model.search("lme/general/dataimport/file-import-field", body).then(searchResult => {
            this.updateSchemaFieldInfo(searchResult?.modelRows?.[0]);
        });
    }
}
